import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  HttpResponse,
  HttpUtilService,
} from "../http-util.service";
import {
  Role,
  Team,
  User,
} from "../../models/administration/user-management/user-management.model";

const SERVICE_NAME = "KapsUserService.asmx";

@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  constructor(private http: HttpUtilService) {}

  getAll(): Observable<HttpResponse<User[]>> {
    return this.http.get(`${SERVICE_NAME}/GetAll`);
  }

  getUserDetail(id: string): Observable<HttpResponse<User>> {
    return this.http.get(`${SERVICE_NAME}/GetUserDetail`, {
      params: { id },
    });
  }

  deleteUser(id: string): Observable<HttpResponse<{}>> {
    return this.http.post(`${SERVICE_NAME}/Delete`, { id });
  }

  getAllActiveRoles(): Observable<HttpResponse<Role[]>> {
    return this.http.get("AdminService.asmx/GetAllActiveRoles");
  }

  getAllSalesTeam(): Observable<HttpResponse<Team[]>> {
    return this.http.get(`${SERVICE_NAME}/GetAllSalesTeam`);
  }

  updateUser(userPayload: any): Observable<HttpResponse<{}>> {
    const formattedPayload = this.buildUserPayload(userPayload);
    return this.http.post(`${SERVICE_NAME}/UpdateUser`, { user: formattedPayload });
  }

  addUser(userPayload: any): Observable<HttpResponse<{}>> {
    const formattedPayload = this.buildUserPayload(userPayload, true);
    return this.http.post(`${SERVICE_NAME}/AddUser`, { model: formattedPayload });
  }

  /**
   * Constructs the properly formatted CrmUser payload with correct field order and types
   * @param userData Raw user data object with form values
   * @returns Formatted user payload matching KAPS.Model.UserModel.CrmUser structure
   */
  private buildUserPayload(userData: any, isAdd = false): any {
    return {
      __type: "KAPS.Model.UserModel.CrmUser",
      SystemLoginId: null,
      UserId: userData.UserId,
      LoginId: userData.LoginId,
      RoleId: userData.RoleId,
      RoleName: isAdd ? null : this.toNullable(userData.RoleName),
      FirstName: userData.FirstName,
      LastName: userData.LastName,
      Team: this.toNullable(userData.Team),
      RightsLevel: String(userData.RightsLevel),
      Agent: this.toNullable(userData.Agent),
      DealersStaff: this.toNullable(userData.DealersStaff),
      Address: this.toNullable(userData.Address),
      EmailId: userData.EmailId,
      TelephoneNumber: this.toNullable(userData.TelephoneNumber),
      MobileNumber: this.toNullable(userData.MobileNumber),
      FaxNumber: this.toNullable(userData.FaxNumber),
      SerialNumber: this.toNullable(userData.SerialNumber),
      Status: userData.Status,
      HmgicsId: this.toNullable(userData.HmgicsId),
      Password: this.toNullable(userData.Password),
      ConfirmPassword: this.toNullable(userData.ConfirmPassword),
    };
  }

  private toNullable(value: any): any {
    return value === undefined ? null : value;
  }
}
